import api from '../../../shared/services/api';

const pastasService = {
  listar:    () => api.get('/automacoes/pastas'),
  criar:     (data) => api.post('/automacoes/pastas', data),
  atualizar: (id, data) => api.patch(`/automacoes/pastas/${id}`, data),
  excluir:   (id) => api.delete(`/automacoes/pastas/${id}`),
};

export default pastasService;
